import { CommonApplicationState } from "@teamprevent/common/commonApplicationState";
import { MessageDetails, MessageType } from "@teamprevent/common/messaging/models";

import { OhCase } from "../model";

export const routeIdSelector = (state: CommonApplicationState): string => {
    return state.router.params!.ohCaseId;
};

export const ohCaseSelector = (state: CommonApplicationState): OhCase | undefined => {
    const ohCaseId = routeIdSelector(state);
    return state.ohCases.find(c => c.id === ohCaseId);
};

export const routeCustomersSelector = (state: CommonApplicationState): string => {
    return state.router.params!.customerId;
};

export const routeConversationSelector = (state: CommonApplicationState): string => {
    return state.router.params!.subject;
};

export const caseMessagesSelector = (state: CommonApplicationState): MessageDetails[] => {
    return state.messages;
};

export const previewConversationSelector = (state: CommonApplicationState): string => {
    return state.router.query!.previewConversation;
};

export const subjectSelector = (state: CommonApplicationState): string => {
    return state.router.query!.subject;
};

export const activeCaseMessagesCountSelector = (state: CommonApplicationState): number => {
    let messageCount = 0;

    if (!state.messages) {
        return messageCount;
    }

    state.messages.forEach(m => {
        const topReply = m.messages.sort((a, b) => b.dateCreated.valueOf() - a.dateCreated.valueOf())[0];

        if (topReply.caseMessageType === MessageType.CaseMessage)
        {
            messageCount++;
        }
    });

    return messageCount;
};

export type SelectorState = CommonApplicationState;
